module.exports = __webpack_public_path__ + "img/1F61A.c8cacf96.svg";